import styled from "styled-components";

// dls
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";

const OFFER_MESSAGE_HORIZONTAL_PADDING = "6px";

export const StyledBannerMessage = styled(Text)(({ theme }) => {
    return {
        marginTop: `${theme.spacing.xxSmall}`,
    };
});

export const StyledOfferMessageContainer = styled.div(({ theme }) => {
    return {
        backgroundImage: `linear-gradient(to right, ${theme.colors[theme.colorMode].background_Secondary}, ${
            theme.colors[theme.colorMode].background_Secondary
        }, ${theme.colors[theme.colorMode].background_Primary})`,
        padding: `${theme.spacing.xxSmall} ${OFFER_MESSAGE_HORIZONTAL_PADDING} ${theme.spacing.xxSmall} ${OFFER_MESSAGE_HORIZONTAL_PADDING}`,
        borderRadius: `${theme.spacing.xxSmall}`,
        marginTop: `${theme.spacing.xxSmall}`,
    };
});

export const ViewAllRewardsContainer = styled.div(({ theme }) => {
    return {
        display: "flex",
        alignItems: "center",
        marginTop: theme.spacing.xSmall,
    };
});

export const IconWrapper = styled.div(({ theme }) => {
    return {
        width: theme.spacing.xLarge,
        height: theme.spacing.medium,
    };
});

export const Icon = styled(GenericIcon)(() => {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
    };
});
